import styled from 'styled-components'

export const Wrapper = styled.div`
   
    display:grid;
    margin: 0 auto 0 10%;
    padding: 0 20px;
    max-height: 85vh;
    width:100%;
    
    
    @media screen and (max-width: 400px) {
            max-height:80vh
        }

    h1 {
        color: var(--medGrey);

        @media screen and (max-width: 768px) {
            font-size: var(--fontBig);
        }

    }
`;

export const Content = styled.div`
    display:grid;
   

`;
